import { useState } from 'react';
import { UserApplication } from '../types';
import { CookieNotice } from './CookieNotice';

interface PortalHeaderProps {
  title: string;
  userEmail?: string;
  applications?: UserApplication[];
  navigate?: (path: string) => void;
}

export const PortalHeader = ({ title, applications, userEmail, navigate }: PortalHeaderProps) => {
  const [appsShown, setAppsShown] = useState(false);

  const renderApplication = ({ applicationName, applicationUrl, active }: UserApplication) => {
    if(!active) return null;
    return (
      <div
        className="py-3 px-4 flex flex-row justify-between border-[1px] border-secondary-deep-blue-80 cursor-pointer hover:text-solid-bold-green hover:border-solid-bold-green"
        onClick={() => {
          window.open(applicationUrl, '_blank');
        }}
      >
        <p className="text-md">{applicationName}</p>
        <img src="/externalLinkButtonActive.svg" className="h-6 ml-4 self-end" />
      </div>
    );
  };

  return (
    <div>
      <CookieNotice />
      <div className="flex flex-col w-full text-xl tracking-normal leading-5 whitespace-nowrap bg-stone-100 border-slate-800 text-slate-950 max-md:max-w-full">
        <header className="flex justify-between px-4 py-1.5 bg-stone-100 border-slate-800 max-md:flex-wrap">
          <div className="flex gap-5">
            <img
              src="/starkBlueLogo.png"
              alt="Logo"
              className="h-10 mt-7 col-start-1 col-end-4 cursor-pointer"
              onClick={() => navigate && navigate('/')}
            />
            <h1 className="flex-1 text-ellipsis max-md:max-w-full self-end">{title}</h1>
          </div>
          <div className="flex gap-4 items-end">
            <a className="text-base">{userEmail}</a>
            <img src="/user.png" className="h-5 mb-1" />
            <div
              className={`ml-10 mr-1 translate-y-1 border-2 ${appsShown ? 'bg-secondary-deep-blue-70 border-secondary-deep-blue-70 rounded-full' : 'border-transparent'}`}
            >
              <img
                src="/appsIcon.svg"
                className="cursor-pointer h-8"
                onClick={() => setAppsShown(!appsShown)}
              />
            </div>
          </div>
        </header>
      </div>
      <div className="border-b-[1px] border-secondary-deep-blue-80 pb-4 mb-4"></div>
      {appsShown && applications && (
        <div className="fixed right-1 top-[84px] bg-solid-deep-blue border-2 border-secondary-deep-blue-80">
          {applications.map(renderApplication)}
        </div>
      )}
    </div>
  );
};
